(function () {
  // Sections opt in by wrapping their markup in <template data-lazy-content> and
  // adding data-lazy-template (+ a min-height placeholder) to the section element.
  // The template is parsed but not rendered (and its images are not downloaded)
  // until the section scrolls near the viewport, at which point it is cloned in.
  function activateTemplate(el) {
    if (el.dataset.lazyActivated === 'true') return;
    el.dataset.lazyActivated = 'true';

    const template = el.querySelector('template[data-lazy-content]');
    if (!template) return;

    el.appendChild(template.content.cloneNode(true));
    template.remove();
    el.removeAttribute('style');

    // Re-run scroll-reveal animations against the newly-inserted content if present.
    if (typeof initializeScrollAnimationTrigger === 'function') {
      initializeScrollAnimationTrigger(el);
    }
  }

  function init() {
    const templateSections = document.querySelectorAll('[data-lazy-template]');
    if (!templateSections.length) return;

    // No IntersectionObserver support: just render everything immediately.
    if (!('IntersectionObserver' in window)) {
      templateSections.forEach(activateTemplate);
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            obs.unobserve(entry.target);
            activateTemplate(entry.target);
          }
        });
      },
      { rootMargin: '400px 0px', threshold: 0.01 }
    );

    templateSections.forEach((el) => observer.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
